import React from 'react'

import ProductListLoaded from 'components/ProductsList/ProductListLoaded'

const ProductsList = ({loadMoreRequest, data, setData, handleSearch, searchValue, resultsHeading}) => (
  data.items ? (
    <ProductListLoaded
      items={data.items}
      loadMoreRequest={loadMoreRequest}
      setData={setData}
      handleSearch={handleSearch}
      searchValue={searchValue}
      resultsHeading={resultsHeading}
    />
  ) : data.loading ? (
    'loading...'
  ) : data.init || data.tooShort ? (
    ''
  ) : (
    <p>{data.error ?? 'Unknown error occurred.'}</p>
  )
)

export default ProductsList
